import React from 'react';
import { rootClsPrefix as clsPrefix } from '../constants';
import CapIcon from '../../CapIcon';

const InputBox = ({
  value,
  setValue,
  showSend,
  loading,
  placeholder,
  onSubmit,
}) => {
  return (
    <div className={`${clsPrefix}-input-border`} data-loading={loading.toString()}>
      <form
        onSubmit={e => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <CapIcon
          type="three-stars"
          className={`${clsPrefix}-three-stars-img`}
        />
        <input
          className={`${clsPrefix}-input-box`}
          placeholder={placeholder}
          value={value}
          onChange={e => setValue(e.target.value)}
        />
        {showSend ? (
          <CapIcon
            aria-label="clear input"
            type="close"
            className={`${clsPrefix}-send-img`}
            onClick={e => setValue('')}
          />
        ) : (
          <CapIcon
            type="send-filled"
            className={`${clsPrefix}-send-img`}
            onClick={onSubmit}
            data-testid='send-button'
          />
        )}
      </form>
    </div>
  );
};

export default InputBox;
